export const WEEKS = ["Weeks 1-4", "Weeks 5-8", "Weeks 9-12"] as const;
